"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Image = _interopRequireDefault(require("../Image"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var _Collection = _interopRequireDefault(require("@deosite/ui-entities/Collection"));
var _core = require("@commerce-ui/core2");
var __jsx = _react["default"].createElement;
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var CollectionCard = function CollectionCard(props) {
  var collection = props.collection;
  var translations = {
    startingAt: (0, _langLibrary["default"])("starting at"),
    more: (0, _langLibrary["default"])("more")
  };
  var title = collection.title,
    subtitle = collection.subtitle,
    colors = collection.colors,
    moreAvailable = collection.moreAvailable,
    lowestPrice = collection.lowestPrice,
    mainImage = collection.mainImage,
    thumbnails = collection.thumbnails,
    link = collection.link;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Box["default"], {
    sx: {
      pb: "s7",
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "grid",
      gridTemplateColumns: "2.7fr 1fr",
      gridTemplateRows: "auto auto",
      gap: "1px"
    }
  }, __jsx(_Image["default"], {
    image: mainImage,
    sx: {
      gridColumn: 1,
      gridRow: "1 / span 2",
      aspectRatio: 0.75
    },
    overlay: true
  }), thumbnails && thumbnails.slice(0, 2).map(function (thumbnail, index) {
    return __jsx(_Image["default"], {
      image: thumbnail,
      sx: {
        gridColumn: 2,
        gridRow: index === 0 ? 1 : 2,
        aspectRatio: 1,
        $objectFit: "cover"
      },
      overlay: true,
      key: index
    });
  })), __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "heading3",
      textAlign: "left",
      pr: "s7",
      mt: "s7",
      mb: "s5",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      alignItems: "center"
    },
    as: "h3"
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      mr: "s6",
      display: "block"
    }
  }, title), " ", __jsx(ArrowRightIcon, null)), __jsx(_Box["default"], {
    sx: {
      color: "neutral700",
      font: "xs",
      pr: "s7",
      textAlign: "left"
    }
  }, subtitle, lowestPrice && translations.startingAt + " " + priceWithCurrency(lowestPrice)), __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700",
      pr: "s7",
      mt: "s5"
    }
  }, colors && colors.slice(0, 5).map(function (color, index) {
    return __jsx(_Box["default"], {
      sx: {
        bg: color,
        display: "inline-block",
        width: "16px",
        height: "16px",
        mr: 1,
        border: "1px",
        borderStyle: "solid",
        borderColor: "neutral"
      },
      key: index
    }, "\xA0");
  }), colors && colors.length > 0 && moreAvailable && __jsx(_Box["default"], {
    sx: {
      pl: (0, _core.lin)("s7", "s5")
    },
    as: "span"
  }, moreAvailable > 0 && "+" + moreAvailable + " " + translations.more)), __jsx(Link, {
    route: link
  }, __jsx(_LinkRaw["default"], {
    title: title,
    sx: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%"
    }
  })));
};
var _default = CollectionCard;
exports["default"] = _default;